// We select the element we want to target
const footerElement = document.querySelector("footer");
const scrollToTopBtn = document.querySelector(".scroll-to-top-button");
const rootElement = document.documentElement;
if(footerElement && scrollToTopBtn){
  // Next we want to create a function that will be called when that element is intersected
  function isFooterInView(entries, observer) {
    // The isFooterInView will return an array of entries, even if you are only observing a single item
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        // Show button
        scrollToTopBtn.classList.add("show-btn");
      } else {
        // Hide button
        scrollToTopBtn.classList.remove("show-btn");
      }
    });
  }

  function scrollToTop() {
    rootElement.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  }
  scrollToTopBtn.addEventListener("click", scrollToTop);

  // Next we instantiate the observer with the function we created above. This takes an optional configuration
  // object that we will use in the other examples.
  let footerElementObserver = new IntersectionObserver(isFooterInView);
  // Finally start observing the target element
  footerElementObserver.observe(footerElement);
}
